import { DatePicker } from "./DatePicker";
import { Button } from "./ui/button";

const iso = (d) => d.toLocaleDateString("en-CA");
const presets = () => {
  const now = new Date();
  const weekStart = new Date(now); weekStart.setDate(now.getDate() - 6);
  return [
    ["Today", iso(now), iso(now)],
    ["Last 7 days", iso(weekStart), iso(now)],
    ["This month", iso(new Date(now.getFullYear(), now.getMonth(), 1)), iso(now)],
    ["All", "", ""],
  ];
};

export const Filters = ({ start, end, setRange }) => (
  <div className="flex flex-wrap items-end gap-3" data-testid="date-filter-range">
    <div>
      <label className="font-mono text-[11px] uppercase tracking-widest text-muted-c">From</label>
      <DatePicker value={start} onChange={(v) => setRange(v, end)} clearable placeholder="Start" className="w-44 mt-1" testid="filter-start-date" />
    </div>
    <div>
      <label className="font-mono text-[11px] uppercase tracking-widest text-muted-c">To</label>
      <DatePicker value={end} onChange={(v) => setRange(start, v)} clearable placeholder="End" className="w-44 mt-1" testid="filter-end-date" />
    </div>
    <div className="flex flex-wrap gap-1">
      {presets().map(([label, s, e]) => (
        <Button key={label} variant="outline" size="sm" onClick={() => setRange(s, e)}
          className={`rounded-none h-9 ${start === s && end === e ? "border-brand text-brand" : ""}`}
          data-testid={`filter-preset-${label.toLowerCase().replace(/\s+/g, "-")}`}>{label}</Button>
      ))}
    </div>
  </div>
);
